import { FC } from 'react'
import { Modal } from 'Components/Modal/Modal'
import { FeeScheduleForm } from './FeeScheduleForm'
import { CountryCode } from 'Utils/types/countries'
import { FeeSchedule } from 'Utils/types/employerInfo'

export type FeeScheduleTarget = {
  countryCode: CountryCode
  feeSchedule: FeeSchedule | null
}

type FeeScheduleModalProps = {
  showModal: boolean
  setShowModal: (show: boolean) => void
  target: FeeScheduleTarget | null
}

export const FeeScheduleModal: FC<FeeScheduleModalProps> = ({
  showModal,
  setShowModal,
  target
}) => {
  return (
    <Modal showModal={showModal} setShowModal={setShowModal} maxWidth={640} minWidth={640} overflow>
      {target && (
        <FeeScheduleForm
          key={`${target.countryCode}-${target.feeSchedule?.id ?? 'new'}`}
          closeModal={() => setShowModal(false)}
          countryCode={target.countryCode}
          feeSchedule={target.feeSchedule}
        />
      )}
    </Modal>
  )
}
